<template>
  <div class="emendas-por-ano">
    <div class="row">
      <PublicHeader :title="'Emendas do ano'">
        <div class="col-xs-12 col-sm-6">
          Aqui você encontra a lista e os detalhes de todas as emendas do ano de
          <SelectAnoEmendas />.
        </div>
      </PublicHeader>
    </div>
    <div class="row">
      <div class="container">
        <Breadcrumb :links="breadcrumb" />
        <div class="row">
          <div class="col-xs-12">
            <h3>Emendas de {{ ano }}</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-6">
            <input
              type="text"
              class="form-control"
              placeholder="Digite o nome do vereador, secretaria ou descrição..."
              aria-placeholder="Digite o nome do vereador, secretaria ou descrição..."
              v-model="filtros.descricao"
            />
          </div>
          <div class="col-xs-12 col-sm-6 text-right">
            <button class="btn btn-default" @click="downloadToCSV()">
              <font-awesome-icon :icon="'file-download'" /> Exportar para CSV
            </button>
          </div>
          <div class="col-xs-12">
            <DataTable :dados="emendas" :fields="dataFields">
              <template slot="rowrender" slot-scope="props">
                <button
                  title="Exibir detalhes"
                  type="button"
                  class="btn btn-primary"
                  @click="showDetails(props.rowData)"
                >
                  <font-awesome-icon :icon="'search'"></font-awesome-icon>
                  <span class="sr-only">Exibir detalhes</span>
                </button>
              </template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
    <SideEmendas ref="side-emendas" :navs="navs" :emenda="emenda" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  PublicHeader,
  NoApiTable as DataTable,
  Breadcrumb,
  SideEmendas,
  SelectAnoEmendas
} from '../../../components'
import { formatarMoeda, exportCSVFile } from '../../../utils'
import { dataFields, navs } from './emendasGeral'

export default {
  components: {
    PublicHeader,
    DataTable,
    Breadcrumb,
    SideEmendas,
    SelectAnoEmendas
  },
  data() {
    return {
      emenda: {},
      navs,
      dataFields,
      filtros: {
        descricao: ''
      }
    }
  },
  methods: {
    formatarMoeda,
    showDetails(emenda) {
      const [nav] = this.navs

      nav.titulo = `Detalhes da emenda`
      nav.subtitulo = `Emenda nº ${emenda.numero} / ${emenda.ano}`
      nav.subtDetalhe = emenda.nome_orgao
      this.emenda = emenda

      this.$refs['side-emendas'].$emit('abreModal', nav.identidade)
    },
    downloadToCSV() {
      const headers = {
        numero: 'Emenda nº',
        vereador: 'Vereador',
        secretaria: 'Secretaria',
        descricao: 'Descrição',
        valor: 'Valor',
        saldo: 'Saldo'
      }

      exportCSVFile(
        headers,
        [
          ...this.emendas.map(item => {
            return {
              numero: item.numero,
              vereador: item.vereador.nome,
              secretaria: item.nome_orgao,
              descricao: item.descricao,
              valor: Number(item.valor)
                .toFixed(2)
                .replace('.', ','),
              saldo: Number(item.saldo)
                .toFixed(2)
                .replace('.', ',')
            }
          })
        ],
        'emendas'
      )
    }
  },
  computed: {
    breadcrumb() {
      return [
        {
          label: 'Emendas Parlamentares',
          named_link: { name: 'emendas_parlamentares' }
        },
        {
          label: this.ano
        }
      ]
    },
    ...mapState({
      ano: state => state.emendas_parlamentares.ano,
      emendasStore: state => state.emendas_parlamentares.emendas
    }),
    emendas() {
      if (this.filtros.descricao) {
        const filter = item => {
          const { vereador, sigla_orgao, descricao } = item

          const termo = this.filtros.descricao.toUpperCase()
          return (
            vereador.nome.toUpperCase().includes(termo) ||
            sigla_orgao.toUpperCase().includes(termo) ||
            descricao.toUpperCase().includes(termo)
          )
        }

        return this.emendasStore.filter(filter)
      }

      return this.emendasStore
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/public/emendas_parlamentares/DetalhesPorAno.vue